import { api } from "@/features/utils/fetch-server";
import type {
  NotificationDigest,
  NotificationCandidate,
  NotificationSetting,
  NotificationSettingPatch,
  NotificationTopicView,
} from "../types";

export class NotificationsAPI {
  /** The subjects this company runs, their settings, and who can receive them. */
  static listTopics = async (
    clientId: string,
  ): Promise<{
    topics: NotificationTopicView[];
    candidates: NotificationCandidate[];
  }> =>
    api.get<{
      topics: NotificationTopicView[];
      candidates: NotificationCandidate[];
    }>(`/api/notifications/v1/${clientId}/topics`);

  /** The company's setting for one subject. A `null` field resets it to the default. */
  static updateSetting = async (
    clientId: string,
    topic: string,
    patch: NotificationSettingPatch,
  ): Promise<{ setting: NotificationSetting }> =>
    api.put<{ setting: NotificationSetting }, typeof patch>(
      `/api/notifications/v1/${clientId}/topics/${topic}`,
      patch,
    );

  /** What a digest would say right now. Sends nothing. */
  static preview = async (
    clientId: string,
    topic: string,
  ): Promise<{ digest: NotificationDigest | null }> =>
    api.get<{ digest: NotificationDigest | null }>(
      `/api/notifications/v1/${clientId}/topics/${topic}/preview`,
    );
}
